// Session <-> patient-document link transport. All three operations route
// under `/sessions/{id}/patient-documents`. Each call resolves the same
// scribeHttpV2 instance through the client registry.
import { getScribeHttpClients } from '@heidi/api/client';

import type {
  CreateSessionPatientDocumentLinksRequest,
  SessionPatientDocumentLinkListResponse,
} from '../../contracts';

/** @domain session */
export const getSessionPatientDocumentLinks = (sessionId: string) => {
  return getScribeHttpClients().scribeHttpV2.get<SessionPatientDocumentLinkListResponse>(
    `/sessions/${sessionId}/patient-documents`
  );
};

/** @domain session */
export const linkPatientDocumentsToSession = (
  sessionId: string,
  patientDocumentIds: string[]
) => {
  const data: CreateSessionPatientDocumentLinksRequest = {
    patient_document_ids: patientDocumentIds,
  };
  return getScribeHttpClients().scribeHttpV2.post<SessionPatientDocumentLinkListResponse>(
    `/sessions/${sessionId}/patient-documents`,
    data
  );
};

/** @domain session */
export const unlinkPatientDocumentFromSession = (
  sessionId: string,
  patientDocumentId: string
) => {
  return getScribeHttpClients().scribeHttpV2.delete<void>(
    `/sessions/${sessionId}/patient-documents/${patientDocumentId}`
  );
};
